// Media Library Upload Limits & Constants

// Per-upload limits
export const MAX_FILES_PER_UPLOAD = 5; // Max files per batch upload
export const MAX_UPLOAD_SIZE_PER_BATCH = 1000 * 1024 * 1024; // 500MB per batch

// Per-file limits
export const MAX_FILE_SIZE = 1000 * 1024 * 1024; // 500MB per individual file

// Storage quota per store
export const MAX_STORE_STORAGE = 2 * 1024 * 1024 * 1024; // 2GB total storage

// Accepted file types
export const ACCEPTED_PHOTO_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
export const ACCEPTED_VIDEO_TYPES = ['video/mp4', 'video/quicktime']; // MP4, MOV
export const ACCEPTED_FILE_EXTENSIONS = '.jpg,.jpeg,.png,.webp,.mp4,.mov';

// Chunked video upload settings
export const VIDEO_CHUNK_SIZE = 5 * 1024 * 1024; // 6MB per chunk (Cloudinary recommends 5-20MB)
export const MAX_CHUNK_RETRIES = 3; // Number of retry attempts per chunk
export const CHUNK_RETRY_BASE_DELAY = 1000; // 1 second base delay, doubles each retry (exponential backoff)
export const CHUNK_UPLOAD_TIMEOUT = 120000; // 2 minutes timeout per chunk
export const SMALL_VIDEO_THRESHOLD = 20 * 1024 * 1024; // Videos under 20MB use single upload

// Helper to format bytes to human readable
export const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

